<template>
  <router-link :to="routerLink" v-if="routerLink!==''" class="button" :class="color">{{label}}</router-link>
  <a :href="link" class="button" :class="color" v-else>{{label}}</a>
</template>

<script>
  export default {
    name: "ButtonLink",
    props: {
      label: {
        type: String,
        default: 'Button'
      },
      link: {
        type: String,
        default: '#'
      },
      routerLink: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: 'blue'
      }
    }
  }
</script>

<style scoped>
  .button {
    position: relative;
    display: inline-block;
    border: 2px solid #102D61;
    padding: 10px 20px;
    font-weight: 500;
    line-height: 24px;
    color: #102D61;
    text-decoration: none;
    margin: 10px -2px;
    border-radius: 24px;
    z-index: 1;
    transition: 0.2s ease;
  }
  .button:before {
    content: "";
    position: absolute;
    display: block;
    left: 50%;
    right: 50%;
    border-radius: 22px;
    top: 0;
    bottom: 0;
    opacity: 0;
    background-color: #102D61;
    transition: 0.2s ease;
    z-index: -1;
    box-shadow: 0 0 0 1px #102D61;
  }
  .button:hover {
    color: white;
  }
  .button:hover:before {
    left: 0;
    right: 0;
    opacity: 1;
  }
  .button.white {
    color: white;
    border-color: white;
  }
  .button.white:before {
    background-color: white;
    box-shadow: 0 0 0 1px white;
  }
  .button.white:hover {
    color: #102D61;
  }
</style>